import { MenuItem, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

export const SelectInput = ({
  name,
  label,
  required = false,
  helper = {},
  items = [],
  sx = {},
  disabled = false,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      rules={{ required }}
      render={({
        field: { ref, onChange, value, ...field },
        fieldState: { error },
      }) => (
        <TextField
          {...field}
          disabled={disabled}
          sx={sx}
          select
          required={required}
          label={label}
          value={value ?? ""}
          error={error !== undefined}
          onChange={(evt) => onChange(evt.target.value)}
          helperText={
            error ? (
              helper?.[name]?.[error.type] ? (
                helper?.[name]?.[error.type]
              ) : (
                <FormattedMessage
                  id={`common.${error.type}`}
                  values={{ field: label }}
                />
              )
            ) : (
              ""
            )
          }
        >
          {items.map((i) => (
            <MenuItem key={i.value} value={i.value}>
              {i.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};
